import { __assign } from "tslib";
import { $localStorage } from '@tajawal/web-core-sdk-v2/lib/services/local-storage.service';
import { pushDataLayer } from '@tajawal/web-core-sdk-v2/lib/utils/gtm.utils';
export function getGA4SystemProperties() {
    return $localStorage.get('MyAccount_GA4_System_Props');
}
export function pushGA4Event(event_name, extraProps) {
    if (extraProps === void 0) { extraProps = {}; }
    var systemProps = getGA4SystemProperties();
    pushDataLayer(__assign(__assign({ event_name: event_name }, systemProps), extraProps));
}
//# sourceMappingURL=analytics.utils.js.map